"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "import-text" };
const _hoisted_2 = { class: "role-list" };
exports.default = (0, vue_1.defineComponent)({
    __name: 'RequiredStaffImportText',
    props: {
        roles: { default: () => [] },
        userId: {},
        branchId: {}
    },
    setup(__props) {
        const props = __props;
        function exportCsv() {
            window.open(`/dashboard/${props.userId}/roles/role_staff_requirement_bulk_export?c=${props.branchId}`);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("div", null, " CSVファイルから業務ごとの日別必要人数を一括登録できます。 ", -1 /* CACHED */)),
                _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("div", null, " 下記の業務コードを使用して業務を選択してください。 ", -1 /* CACHED */)),
                (0, vue_2.createElementVNode)("ul", _hoisted_2, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(props.roles, (role) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                            key: role.ID
                        }, (0, vue_2.toDisplayString)(role.Name) + " - " + (0, vue_2.toDisplayString)(role.ID), 1 /* TEXT */));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("div", null, " または ", -1 /* CACHED */)),
                (0, vue_2.createElementVNode)("button", {
                    class: "oplus-btn oplus-create-btn font-sm",
                    onClick: exportCsv
                }, " 既存の業務コードと必要人数の一覧をダウンロードする ")
            ]));
        };
    }
});
